import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Information',
    security: 'Risks',
    securityDescription: `By depositing you accept several layers of <a href={contractLink} target="_blank" rel="norefferer">smart contract</a> risks: the vault, bridge, and DeFi protocols. Additionally, the DeFi strategies contain impermanent loss, duration and bad debt risks. The vault doesn't take leveraged positions - hence no liquidation risks are assumed.`,

    ownership: 'Goals',
    ownershipDescription:
      'The Bitcoin Sonic Vault, developed in partnership with Veda, is an automated yield management solution designed to maximize BTC-denominated returns by strategically deploying deposits across various products within the DeFi ecosystem on Sonic chain',
    bridging: 'Strategies',
    bridgingDescription:
      'The Vault’s strategies include providing liquidity on DEX platforms like Curve, lending on platforms like Euler and Silo, and fixed yield farming on Pendle. Additionally, the Vault facilitates automated compounding by continuously converting all accrued DeFi rewards into LBTC.',
  },
};
